export const ALLERT_EDIT_QUERY_KEY = 'allert-edit-data';
